export const DEFAULT_ELEMENT_STYLE_OPTIONS = {
  fonts: [
    { cssSrc: "https://fonts.googleapis.com/css2?family=Overpass:wght@400;700&display=swap" },
  ],
  appearance: {
    theme: "flat",
    variables: {
      fontFamily: '"Overpass", sans-serif',
      fontSizeBase: "13.9292px",
      spacingGridRow: "20px",
      colorBackground: "#f6f6f6",
    },

    rules: {
      ".Input": {
        border: "1px solid #eff0f2",
        borderRadius: "0.5rem",
        padding: "0.75em 1.25em",
        fontSize: "16px",
        lineHeight: "20px",
        backgroundColor: "#fff",
        fontWeight: "500",
      },
      ".Input:focus": {
        outline: "none",
        boxShadow: "none",
        borderColor: "#4f5052",
      },
      ".Input--invalid": {
        boxShadow: "none",
        borderColor: "#df1b41",
      },
      ".Input::placeholder": { color: "#bbb" },
      ".Label": {
        fontSize: "12px",
        fontWeight: "bold",
        textTransform: "uppercase",
        letterSpacing: "1px",
        color: "#4f5052",
        marginBottom: "8px",
        lineHeight: "1.33",
      },
      ".TermsText": {
        fontSize: "12px",
        color: "#4f5052",
        letterSpacing: "0.25px",
        fontWeight: "500",
        lineHeight: "1.33",
      },
    },
  },
};

export const DEFAULT_PAYMENT_ELEMENT_OPTIONS = {
  terms: { card: "never" },
  business: { name: "Stadium" },
};
